'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUngatedForSalesPro2017 = exports.isUngatedForBlocking = exports.getGates = undefined;

var _reselect = require('reselect');

var _Gates = require('conversations-core/constants/Gates');

var getGates = exports.getGates = function getGates(state) {
  return state.auth.gates;
};

var isUngatedForBlocking = exports.isUngatedForBlocking = (0, _reselect.createSelector)([getGates], function (gates) {
  return gates.includes(_Gates.BLOCKING);
});

var isUngatedForSalesPro2017 = exports.isUngatedForSalesPro2017 = (0, _reselect.createSelector)([getGates], function (gates) {
  return gates.includes(_Gates.SALES_PRO_2017);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/gateSelectors.js
// module id = 293
// module chunks = 0 1